import { useTracks, useTrackTranscription } from '@livekit/components-react'
import { Track } from 'livekit-client'
import { useMemo } from 'react'

export interface TranscriptionMessage {
  timestamp: number
  from: string
  text: string
  isLocal: boolean
}

export function useAllTranscriptions(): TranscriptionMessage[] {
  // Get all microphone tracks (local and remote)
  const audioTracks = useTracks([Track.Source.Microphone], {
    onlySubscribed: false,
  })

  // Get transcriptions for each track
  const track0 = audioTracks[0]
  const track1 = audioTracks[1]
  const track2 = audioTracks[2]
  const track3 = audioTracks[3]

  const { segments: segments0 } = useTrackTranscription(track0)
  const { segments: segments1 } = useTrackTranscription(track1)
  const { segments: segments2 } = useTrackTranscription(track2)
  const { segments: segments3 } = useTrackTranscription(track3)

  // Combine all transcription segments
  const allMessages = useMemo(() => {
    const messages: TranscriptionMessage[] = []

    const allSegmentsWithTrack = [
      { track: track0, segments: segments0 },
      { track: track1, segments: segments1 },
      { track: track2, segments: segments2 },
      { track: track3, segments: segments3 },
    ]

    allSegmentsWithTrack.forEach(({ track, segments }) => {
      if (!track) return

      const participantName =
        track.participant.name || track.participant.identity
      const isLocal = track.participant.isLocal

      segments.forEach(segment => {
        if (segment.text && segment.firstReceivedTime) {
          messages.push({
            timestamp: segment.firstReceivedTime,
            from: participantName,
            text: segment.text,
            isLocal,
          })
        }
      })
    })

    return messages
  }, [
    track0,
    track1,
    track2,
    track3,
    segments0,
    segments1,
    segments2,
    segments3,
  ])

  return allMessages
}
